<template>
  <v-chart :options="options" @contextmenu="contextmenu" />
</template>

<script>
import { format } from 'date-fns';
import bus from '@/utils/bus';
import { comma } from '@/utils/formatter';
import { DEFAULT_COLORS } from '@/constants';
import chartable from '@/mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    values: {
      type: Array,
      required: true,
    },
    xAxisLength: {
      type: Number,
      default: 20,
    },
    colors: {
      type: Array,
      default() {
        return DEFAULT_COLORS;
      },
    },
    animation: {
      type: Boolean,
      default: false,
    },
    areaStyle: {
      type: String,
      default: 'normal',
    },
    contextmenu: {
      type: Function,
      default: e => e,
    },
  },
  computed: {
    options() {
      return {
        animation: this.animation,
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            const param = params[0];
            // BEGIN::Added.by.KWShin.2025.01.21.
            // 이 차트 컴포넌트를 사용하는 쪽에서 차트에서 마우스가 가리키는 시점 데이터의 시각을 알 방법이 없으므로
            // 여기서 그 시각을 구해 버스를 통해 넘겨줌.
            bus.$emit(`line-single-tooltip`, param.data[2]);
            // FINISH::Added.by.KWShin.2025.01.21.
            const contents = [];
            contents.push('<i class="v-icon notranslate mdi mdi-clock-time-four-outline mr-1" style="font-size: 12px; line-height: 10px"></i>');
            contents.push(format(parseInt(param.data[2]), 'yyyy-MM-dd HH:mm:ss'));
            contents.push('<br />');
            contents.push(this.circle(param.color));
            contents.push(comma(param.data[1]));
            return contents.join('');
          },
        },
        xAxis: {
          type: 'category',
          axisLine: { show: false },
          axisLabel: { show: false },
          data: this.values.map(v => v.name),
        },
        yAxis: {
          show: false,
          axisLabel: { show: false },
        },
        series: this.series,
      };
    },
    series() {
      return [
        {
          type: 'line',
          showSymbol: false,
          itemStyle: { color: this.colors[0] },
          lineStyle: { width: 1 },
          areaStyle: this.areaStyles,
          label: { show: false },
          smooth: false,
          // smoothMonotone: 'x',
          data: this.values.map((item, index) => [index, item.value, item.name]),
        },
      ];
    },
    areaStyles() {
      let style = {};
      if (this.areaStyle == 'gradation') {
        style = this.areaStyleGradation(this.colors[0]);
      } else if (this.areaStyle == 'linearGradient') {
        style = this.areaStyleLinearGradient(this.colors[0], 15, 30);
      } else if (this.areaStyle == 'spinLinearGradient') {
        style = this.areaStyleSpinLinearGradient(this.colors[0], 15, 30);
      }
      return style;
    },
  },
};
</script>
